export enum MenuList {
    VisualizarCitas = 0,
    AgendarNuevasCitas = 1,
    Recepcion = 2,
    ListadoDeAgendas = 3,
    Valimed = 4,
    Contactos= 5,
    Memoria= 6,
    PuestoVS= 7
}